export default __webpack_public_path__ + "static/media/step4_1.bfdae84f.png";